let activePopup = null;
import { morphSection, sectionRenderer } from '@theme/section-renderer';
document.addEventListener('click', (e) => {
  const item = e.target.closest('.sbt-item-container[data-has-products="true"]');
  if (!item) return;
  const mainPopup = document.getElementById('main-shop-by-theme-popup');
  const popupTemplate = document.getElementById('sbt-popup-template');
  const productItemTemplate = item.querySelector('.sbt-products-template');
  mainPopup.innerHTML = '';
  mainPopup.classList.add('active');
  const clone = popupTemplate.content.cloneNode(true);
  const popup = clone.querySelector('.sbt-popup');
  const popupImage = popup.querySelector('.sbt-popup-image');
  const popupProductsWrap = popup.querySelector('.sbt-popup-products');
  if (productItemTemplate) {
    popupProductsWrap.appendChild(
      productItemTemplate.content.cloneNode(true)
    );
  }
  const itemImage = item.querySelector('img');
  if (itemImage && popupImage) {
    popupImage.src = itemImage.src;
    popupImage.alt = itemImage.alt || '';
  }
  mainPopup.appendChild(popup);
  activePopup = popup;
  const closeBtn = popup.querySelector('.sbt-close');
  const overlay = popup.querySelector('.sbt-popup-overlay');
  closeBtn.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);
  document.addEventListener('keydown', handleEsc);
  function closePopup() {
    mainPopup.classList.remove('active');
    setTimeout(() => {
      mainPopup.innerHTML = '';
      activePopup = null;
    }, 300);

    document.removeEventListener('keydown', handleEsc);
  }
  function handleEsc(e) {
    if (e.key === 'Escape') {
      closePopup();
    }
  }
});

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('.sbt-add-all');
  if (!btn) return;
  if (btn.classList.contains('loading')) return;
  const popup = btn.closest('.sbt-popup');
  if (!popup) return;
  btn.classList.add('loading');
  btn.innerText = 'Adding...';
 try {
  const inputs = popup.querySelectorAll(
    'form[action="/cart/add"] input[name="id"]'
  );
  const items = [];
  inputs.forEach(input => {
    if (input.value) {
      items.push({
        id: input.value,
        quantity: 1
      });
    }
  });
  if (!items.length) {
    console.warn('No products found');
    btn.innerText = 'No Products';
    btn.classList.remove('loading');
    return;
  }
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ items })
  });
  if (!res.ok) throw new Error('Failed to add');
  btn.innerText = 'Added ✓';
  const cartItemsComponents = document.querySelectorAll('cart-items-component');
  await Promise.all(
    Array.from(cartItemsComponents).map(item =>
      sectionRenderer.renderSection(item.dataset.sectionId, { cache: false })
    )
  );
  document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
  document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
  document.dispatchEvent(new CustomEvent('open-cart'));
  btn.innerText = 'Add All to Cart';
} catch (err) {
  console.error(err);
  btn.innerText = 'Error';
} finally {
  btn.classList.remove('loading');
}
});